import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { UseHeadquartersOptions, IHeadquarters } from "../contracts";
import { CursorPaginated } from "@types";

export function useHeadquarters(search: string, options: UseHeadquartersOptions | undefined = {}) {
  const { request } = usePbm2Url();
  options.filter = search ? { name: search } : { name: "" }

  return useQuery(`refund_headquarters:${search}`, async () => {
    const { Refund_headquarters } = await request(
      gql`
        query headquarters(
          $before: String
          $after: String
          $first: Int
          $last: Int
          $filter: Refund_HeadquartersArgsFilterInput!
        ) {
          Refund_headquarters(
            before: $before
            after: $after
            first: $first
            last: $last
            filter: $filter
          ) {
            edges {
              cursor
              node {
                id
                name
                rootCode
                code
              }
            }
            pageInfo {
              hasNextPage
              hasPreviousPage
              pageCount
              totalCount
            }
          }
        }
      `,
      options
    );
    return Refund_headquarters as CursorPaginated<IHeadquarters>;
  });
}

